import { defineStore } from 'pinia'

export const useUiStore = defineStore('ui', {
    state: () => ({
        activePanel: null,   // null | 'design' | 'history' | 'frame' | 'stamp' | 'text' | 'preview'
        isLoading: false,
        isSubmitting: false,
        colorHistories: [],
        isPcMode: false,
    }),
    actions: {
        showPanel(name) { this.activePanel = name },
        hidePanel() { this.activePanel = null },
        setLoading(val) { this.isLoading = val },
        addColorHistory(hex) {
            this.colorHistories = [hex, ...this.colorHistories.filter(c => c !== hex)].slice(0, 8)
        },
        detectPcMode() {
            this.isPcMode = !/iphone|ipod|android.*mobile/i.test(navigator.userAgent)
        },
    },
})
